import React, { useEffect, useState } from 'react'
import OTPInput from 'react-otp-input'
import { StatusBar } from 'components'
import { StyleForm } from './styles'
import { TokenType } from 'typings/index'

interface TokenProps {
    values: { token: TokenType }
    setFieldValue: (field: string, value: Object | string, shouldValidate?: boolean | undefined) => void
    submitForm: () => Promise<void>
    getClassByStatus: (status: string) => string
    isSubmitting?: boolean
    fieldState: {
        status: string
        message: string
    }
}

export const Token: React.VFC<TokenProps> = ({ values, setFieldValue, getClassByStatus, fieldState, submitForm, isSubmitting }) => {
    const [statusToken, setStatusToken] = useState(fieldState)

    useEffect(() => {
        if (values.token.includes(null) && statusToken.status) {
            setStatusToken({ message: '', status: '' })
        }
        if (!values.token.includes(null) && !isSubmitting && !statusToken.status) {
            submitForm()
        }
    }, [values.token, isSubmitting, statusToken.status])

    useEffect(() => {
        setStatusToken(fieldState)
    }, [setStatusToken, fieldState])

    useEffect(() => {
        setFieldValue('token', new Array(6).fill(null))
    }, [])

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const renderInput = (inputProps: any, index: any) => {
        const borderBottomStyle = {
            borderBottom: 'solid 1px #666',
            textAlign: 'center',
            margin: '0 5px',
            width: 'calc(100% / 6)',
            boxSizing: 'border-box',
            fontSize: '32px',
            fontfamily: 'Dasa Sans ,Montserrat ,sans-serif',
            fontWeight: 'bold',
            color: '#363636',
        }

        return (
            <input
                {...inputProps}
                autoComplete="one-time-code"
                className={getClassByStatus(fieldState.status)}
                data-testid={`validate-form-input-${Number(index) + 1}`}
                id={`token-${index}`}
                inputMode="numeric"
                name={`token[${index}]`}
                onKeyPress={event => {
                    if (!/\d/.test(event.key)) {
                        event.preventDefault()
                    }
                }}
                style={borderBottomStyle}
                type="tel"
            />
        )
    }

    return (
        <StyleForm>
            <div className="form__validate-form">
                <OTPInput
                    numInputs={6}
                    onChange={otp => {
                        const numericOTP = otp.replace(/\D/g, '')
                        setFieldValue(
                            'token',
                            numericOTP
                                .split('')
                                .map(Number)
                                .concat(new Array(6 - numericOTP.length).fill(null)),
                        )
                    }}
                    renderInput={(inputProps, index) => renderInput(inputProps, index)}
                    shouldAutoFocus={true}
                    value={values.token.join('')}
                />
            </div>
            {fieldState.status && <StatusBar message={fieldState.message} status={fieldState.status} />}
        </StyleForm>
    )
}
